import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { Router } from "@angular/router";
import {
  NbComponentStatus,
  NbDialogService,
  NbGlobalPhysicalPosition,
  NbToastrService,
} from "@nebular/theme";

import { convertTimestamp } from "../../@core/utils/convertTimestamps.service";

import { replace, remove, clone, find } from "lodash";
import { Employee } from "../../models/employee.model";

import { EmployeeService } from "../../services/employee.service";

import { DialogEmployeeComponent } from "../dialog-employee/dialog-employee.component";
import { UserService } from "../../@core/services/user.service";
import { User } from "../../@core/data/users";
import { map, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

@Component({
  selector: "ngx-view-employees",
  styleUrls: ["./view-employees.component.scss"],
  templateUrl: "./view-employees.component.html",
})
export class ViewEmployeesComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  private destroy$: Subject<void> = new Subject<void>();
  @Input() mode?: string = ""; //admin / develop
  @Input() shopId?: string = "";
  employees?: Employee[] = [];
  employee: Employee = new Employee();

  loading = false;
  submitted = false;
  diaForm: FormGroup;

  strSearch = "";
  uid = "anonymous";

  companyId = "anonymous";
  @ViewChild("title") title: ElementRef;
  @ViewChild("mobile") mobile: ElementRef;
  isMoreInfo = true;

  constructor(
    private userService: UserService,
    private employeeService: EmployeeService,
    private router: Router,
    private fb: FormBuilder,
    private dialogService: NbDialogService,
    private toastrService: NbToastrService
  ) {}

  ngOnInit(): void {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;
          this.companyId = user.companyId;

          if (!this.shopId || this.shopId == "") {
            this.shopId = user.shopId;
          }
        } else {
          this.uid = "anonymous";
          this.companyId = "anonymous";
        }
        this.getEmployees();
      });

    const fullNameValidators = [
      Validators.minLength(1),
      Validators.maxLength(250),
      Validators.required,
    ];
    const mobileValidators = [
      Validators.minLength(9),
      Validators.maxLength(11),
      Validators.required,
    ];
    this.diaForm = this.fb.group({
      fullName: ["", fullNameValidators],
      mobile: ["", mobileValidators],
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.isMoreInfo = false;
      this.title.nativeElement.focus();
    }, 1000);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  //Quick create employee
  inputMore() {
    this.isMoreInfo = !this.isMoreInfo;
  }

  inputMobile() {
    if (this.isMoreInfo) {
      this.mobile.nativeElement.focus();
    }
  }

  //load data
  getEmployees() {
    this.loading = true;
    this.employeeService
      .getEmployees(this.shopId)
      .snapshotChanges(["added", "removed"])
      .pipe(
        map((changes) =>
          changes.map((c) => ({
            id: c.payload.doc.id,
            ...c.payload.doc.data(),
            dob: c.payload.doc.data().dob
              ? convertTimestamp(c.payload.doc.data().dob)
              : null,
          }))
        ),
        takeUntil(this.destroy$)
      )
      .subscribe((data) => {
        this.employees = data;

        console.log("getEmployees:", this.employees);

        this.loading = false;
      });
  }

  create() {
    this.employee.shopId = this.shopId;
    this.employee.fullName = this.employee.fullName
      ? this.employee.fullName.trim()
      : "";
    this.employee.mobile = this.employee.mobile
      ? this.employee.mobile.trim()
      : "";

    if (this.employee.fullName.length > 0) {
      this.loading = true;
      this.submitted = true;

      this.employeeService
        .create(this.employee)
        .then((data) => {
          this.employee = new Employee();
          this.title.nativeElement.focus();

          this.loading = false;
          this.submitted = false;
        })
        .catch((err) => {
          this.loading = false;
          this.submitted = false;
        });
    }
  }

  onNew() {
    this.dialogService
      .open(DialogEmployeeComponent, {
        context: {
          header: "Tạo nhà cung cấp",
          mode: "new",
          shopId: this.shopId,
          employee: this.employee,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.employee = new Employee();
        }
      });
  }

  onEdit(item: Employee) {
    if (item) {
      for (let i = 0; i < this.employees.length; i++) {
        if (this.employees[i].id == item.id) {
          this.employees[i] = item;
          break;
        }
      }
    }
  }

  onDelete(value) {
    remove(this.employees, (e) => {
      return e.id == value;
    });
  }

  //Control event
  private showToast(type: NbComponentStatus, title: string, body: string) {
    const config = {
      status: type,
      destroyByClick: true,
      duration: 2000,
      hasIcon: true,
      position: NbGlobalPhysicalPosition.TOP_RIGHT,
      preventDuplicates: false,
    };
    const titleContent = title ? `${title}` : "";

    this.toastrService.show(body, titleContent, config);
  }
}
